export const cabinetHrTypes = {
  DashboardService: Symbol.for('CabinetHrDashboardService'),
  ReportService: Symbol.for('CabinetHrReportService'),

  GetDashboardUseCase: Symbol.for('CabinetHrgetDashboardUseCase'),
  DownloadReportUseCase: Symbol.for('CabinetHrDownloadReportUseCase'),
}
